import { sendPasswordResetEmail, onIdTokenChanged, updateProfile } from 'firebase/auth';
import { getToken } from "firebase/app-check";
import React, { createContext, useContext, useState, useEffect } from 'react'
import { auth, methods  } from '../setup/Firebase'

const AuthContext = createContext();

export function useAuth() {
    return useContext(AuthContext)
}

export function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState()
    const [loading, setLoading] = useState(true)

    function signup(email, password) {
        return methods.createUserWithEmailAndPassword(auth, email, password)
    }

    function createProfile(name, phonr) {
        return updateProfile(auth.currentUser, {displayName: name})
    }

    function login(email, password) {
        
        return methods.signInWithEmailAndPassword(auth, email, password)
    }

    
    function logout() {
        return methods.signOut(auth)
    }

    function resetPassword(email) {
        return sendPasswordResetEmail(auth, email).then((a) => {
          alert("Password reset email sent")
        })
    }

    function changePassword(password) {
        return currentUser.changePassword(password)
    }

    function updateEmail(email) {
        return currentUser.updateEmail(email)
    }



    useEffect(() => {
        const unsubscribe = methods.onAuthStateChanged(auth, (user) => {
            setCurrentUser(user)
            setLoading(false)
        })
        return unsubscribe 
    })
    
    useEffect(() => {
        const unsubscribeClaim = onIdTokenChanged(auth, (user) => {
            setCurrentUser(user); // Update currentUser when token changes
            setLoading(false);
        });
        return unsubscribeClaim;
    }, []);


    const value = {
        currentUser,
        login,
        signup,
        createProfile,
        logout, 
        resetPassword,
        updateEmail,
        changePassword
    }

  return (
    <AuthContext.Provider value={value}>
        {!loading && children}
    </AuthContext.Provider>
  )
}

